let images = document.querySelectorAll('#lpImgGallery img');
    let wrapper = document.getElementById("lpModalWrapper");
    let imgWrapper = document.getElementById("fullImg");
    let close = document.getElementById("lpImgModalClose");
    let next = document.getElementById("lpNextImage");
    let prev = document.getElementById("lpPrevImage");
    let indexOfCurrent = null;

    images.forEach((img, index) => {
        img.addEventListener("click", () => {
            indexOfCurrent = index;
            openModal(indexOfCurrent);
        });
    });

    function openModal(index) {
        wrapper.style.display = "flex";
        imgWrapper.src = images[index].getAttribute('src');
        hideArrows();
        document.body.style.overflow = "hidden";
    }

    close.addEventListener("click", () => closeModal());

    function closeModal() {
        wrapper.style.display = "none";
        document.body.style.overflow = "unset";
    }

    next.addEventListener("click", () => {
        if (indexOfCurrent + 1 <= images.length - 1) {
            indexOfCurrent = indexOfCurrent + 1;
            openModal(indexOfCurrent);
        }
    });

    prev.addEventListener("click", () => {
        if (indexOfCurrent - 1 >= 0) {
            indexOfCurrent = indexOfCurrent - 1;
            openModal(indexOfCurrent);
        }
    });

    function hideArrows() {
        prev.style.display = "flex";
        next.style.display = "flex";
        if (indexOfCurrent == images.length - 1) {
            next.style.display = "none";
        }
        if (indexOfCurrent == 0) {
            prev.style.display = "none";
        }
    }

    document.addEventListener("keydown", ({ key }) => {
        if (key === "Escape") {
            closeModal();
        }
        if (key === "ArrowRight") {
            next.click();
        }
        if (key === "ArrowLeft") {
            prev.click();
        }
    });